export type FieldType = "string" | "number" | "integer" | "boolean" | "object" | "array";

export type SchemaField = {
    id: string;
    name: string;
    type: FieldType;
    required: boolean;
    description: string;
    format: string;
    enumValues: string;
    minimum: string;
    maximum: string;
    children: SchemaField[];
    arrayItemType: FieldType;
};

export const FIELD_TYPES: { value: FieldType; labelKey: string }[] = [
    { value: "string", labelKey: "Text" },
    { value: "number", labelKey: "Number" },
    { value: "integer", labelKey: "Integer" },
    { value: "boolean", labelKey: "True / False" },
    { value: "object", labelKey: "Object" },
    { value: "array", labelKey: "List" },
];

export const STRING_FORMATS = [
    { value: "", labelKey: "None" },
    { value: "date-time", labelKey: "Date & Time (ISO 8601)" },
    { value: "date", labelKey: "Date" },
    { value: "time", labelKey: "Time" },
    { value: "email", labelKey: "Email" },
    { value: "uri", labelKey: "URL" },
    { value: "uuid", labelKey: "UUID" },
    { value: "ipv4", labelKey: "IPv4" },
];
